import React, { Fragment, memo, useCallback, useEffect, useState } from "react";
import SvgCaretDown from "../../assets/icons/SvgCaretDown";
import SvgClose from "../../assets/icons/SvgClose";
import Announcement from "./Announcement";
import DotControls from "../common/DotControls";
import { UseAnnouncementBarMessages } from "../../staticQueries/useAnnouncementBarMessages";
import useEmblaCarousel from "embla-carousel-react";
import LeftArrow from "../common/ArrowsButton/LeftArrow";
import RightArrow from "../common/ArrowsButton/RightArrow";

function ActiveAnnouncemnt({ announcements, setOpen }) {
  const [activeAnnouncement, setActiveAnnouncement] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveAnnouncement(
        (prevState) => (prevState + 1) % announcements.length
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <p
      className="mx-auto cursor-pointer text-xs flex-1 md:flex-[0.33] leading-3 tracking-wide flex gap-2 items-center justify-center text-center"
      role="button"
      onClick={() => setOpen(true)}
    >
      {announcements?.[activeAnnouncement]?.title}
      <SvgCaretDown />
    </p>
  );
}

const Announcements = () => {
  const [isOpen, setOpen] = useState(false);
  const announcements = UseAnnouncementBarMessages();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    dragFree: false,
    containScroll: "trimSnaps",
    slidesToScroll: 1,
    speed: 20,
    loop: true,
  });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  function handleNext() {
    emblaApi.scrollNext();
  }

  function handlePrev() {
    emblaApi.scrollPrev();
  }
  function handleGoTo(slide) {
    emblaApi.scrollTo(slide);
  }

  return (
    <Fragment>
      <ActiveAnnouncemnt announcements={announcements} setOpen={setOpen} />
      <div
        className={`fixed left-0 w-screen h-screen gradientBg text-white ${
          isOpen ? "top-0" : "-top-[100vh]"
        }`}
      >
        {/* Drawer Body */}
        <div className="relative w-full h-full py-9 px-[10px] lg:px-20">
          <div className="flex justify-end relative">
            <div
              className="absolute right-0 lg:-right-5 rounded-full w-10 h-10 cursor-pointer flex items-center justify-center bg-secondary-200
                text-secondary-500"
              onClick={() => setOpen(false)}
            >
              <SvgClose width="16px" height="16px" />
            </div>
          </div>
          <div className="flex justify-center flex-col h-full sm:px-4 md:px-14 lg:px-[30px]">
            {prevBtnEnabled && <LeftArrow onClick={handlePrev} />}
            {nextBtnEnabled && <RightArrow onClick={handleNext} />}
            <div
              className="relative w-full h-auto flex flex-col justify-center mt-auto mb-10 md:mb-auto overflow-hidden"
              ref={emblaRef}
            >
              <div className="flex flex-row">
                {announcements.map((a, index) => (
                  <div
                    key={index}
                    className="relative flex-grow-0 flex-shrink-0 basis-full md:basis-1/2 lg:basis-1/3 block rounded-[10px] bg-transparent overflow-hidden lg:mx-0"
                  >
                    <Announcement key={a.title} {...a} />
                  </div>
                ))}
              </div>
            </div>
            {announcements.length !== 0 && (
              <div className="flex md:hidden mb-auto">
                <DotControls
                  arr={announcements}
                  activeIndex={selectedIndex}
                  animationDuration="500ms"
                  color="white"
                  onClick={(e) => handleGoTo(e.clickedIndex)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default memo(Announcements);
